import FileSaver from "file-saver";

interface DownloadFileType {
  data: string;
  name: string;
  fileType: "csv" | "json";
}

const downloadFile = ({ data, name, fileType }: DownloadFileType) => {
  if (data && name && process.env.NODE_ENV !== "test") {
    const type =
      fileType === "csv"
        ? "data:text/csv;charset=utf-8"
        : "application/json; charset=utf-8";

    const blob = new Blob([data], { type });

    if (!navigator.userAgent.match("CriOS")) {
      FileSaver.saveAs(blob, name + "." + fileType);
    } else {
      const reader = new FileReader();
      reader.onload = function onload() {
        (window.location.href as any) = reader.result;
      };
      reader.readAsDataURL(blob);

      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileURL;
      a.target = "_blank";
      a.download = name + "." + fileType;
      document.body.appendChild(a);
      a.click();
    }
  }
};

export default downloadFile;
